import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

interface ClearSortForVisitsBody {
  estimatedVisitIds: number[];
}

export const useClearSortForVisits = (estimatedVisitIds: number[]) => {
  const queryClient = useQueryClient();
  const user = useSelector((state: any) => state?.login?.user);
  const currentPractice: string | undefined = user?.primaryPracticeId;
  const currentOrg: string | undefined = user?.primaryOrganizationId;
  const path = `${currentPractice}/${endpoints.estimatedVisits}/clear-sort-for-visits`;

  return useMutation(
    [path, estimatedVisitIds],
    async (): Promise<void> => {
      await makeAPIRequestReactQuery<void>(path, undefined, 'PUT', {
        data: { estimatedVisitIds } as ClearSortForVisitsBody,
        headers: {
          practice: currentPractice,
          org: currentOrg,
        },
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          endpoints.patient,
          endpoints.latestImages,
        ]);
      },
    },
  );
};
